export const TAGLIST = [
  {
    id: 1,
    name: "干货满满",
  },
  {
    id: 2,
    name: "强烈安利",
  },
  {
    id: 3,
    name: "通俗易懂",
  },
  {
    id: 4,
    name: "讲解生动",
  },
  {
    id: 5,
    name: "案例丰富",
  },
  {
    id: 6,
    name: "实用有效",
  },
  {
    id: 7,
    name: "条理清晰",
  },
  {
    id: 8,
    name: "内容专业",
  },
];
